import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const DownloadRequestEditStatus = ({
  downloadRequest,
  isAdmin,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <FormGroup className="status-options" check inline>
      <Label
        for="inpStatusPending"
        className={`status-label-pending${(!isAdmin && downloadRequest.status !== 'pending') ? ' hidden' : ''}`}
      >
        <Input
          id="inpStatusPending"
          type="radio"
          name="status"
          value="pending"
          disabled={!isAdmin}
          checked={!downloadRequest.status || downloadRequest.status === 'pending'}
          onChange={handleChange}
        />
        <i className="fas fa-hourglass-half" />
        <span>{intl.formatMessage({ defaultMessage: 'Pending' })}</span>
      </Label>
      <Label
        for="inpStatusAccepted"
        className={`status-label-accepted${(!isAdmin && downloadRequest.status !== 'accepted') ? ' hidden' : ''}`}
      >
        <Input
          id="inpStatusAccepted"
          type="radio"
          name="status"
          value="accepted"
          disabled={!isAdmin}
          checked={downloadRequest.status === 'accepted'}
          onChange={handleChange}
        />
        <i className="far fa-check" />
        <span>{intl.formatMessage({ defaultMessage: 'Accepted' })}</span>
      </Label>
      <Label
        for="inpStatusRejected"
        className={`status-label-rejected${(!isAdmin && downloadRequest.status !== 'rejected') ? ' hidden' : ''}`}
      >
        <Input
          id="inpStatusRejected"
          type="radio"
          name="status"
          value="rejected"
          disabled={!isAdmin}
          checked={downloadRequest.status === 'rejected'}
          onChange={handleChange}
        />
        <i className="far fa-times" />
        <span>{intl.formatMessage({ defaultMessage: 'Rejected' })}</span>
      </Label>
    </FormGroup>
  );
};

DownloadRequestEditStatus.propTypes = {
  downloadRequest: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default DownloadRequestEditStatus;
